e4.quickorder = {
    init: function () {
        if ( jQuery( '.js-e-quickorder' ).length === 1 ) {
            e4.require.js( e4.settings.require.typeahead, function () {
                e4.quickorder.bindEvents();
            } );
        }
    },
    bindEvents: function () {
        jQuery( '.js-e-quickorder-form' ).on( 'submit', function ( event ) {
            event.preventDefault();
            var jSuggestionFirst = jQuery( this ).find( '.js-e-quickorder-suggestions' ).find( '.tt-selectable' ).first();
            if ( jSuggestionFirst.length === 1 ) {
                jSuggestionFirst.trigger( 'click' );
            }
        } ).on( 'click', '.js-e-quickorder-submit', function () {
            jQuery( this.form ).triggerHandler( 'submit' );
        } );
        jQuery( '.js-e-cart' ).on( 'updated.e4.cart', function () {
            e4.quickorder.focus();
        } );

        jQuery( '.js-e-quickorder-input' ).on( 'keydown', function ( event ) {
            if ( event.keyCode === 13 ) {
                var query = jQuery(event.currentTarget).val(),
                    isBulkOfProductIds = e4.quickorder.isBulkOfProductIds(query),
                    isNewlineSeperatedProductIds = e4.quickorder.isNewlineSeperatedProductIds(query);
                if(isBulkOfProductIds){
                    e4.quickorder.addMultiToCart(query);
                } else if(isNewlineSeperatedProductIds){
                    query = query.trim().split(' ').join(',');
                    e4.quickorder.addMultiToCart(query);
                } else {
                    var jSuggestions = jQuery( event.target.form ).find( '.js-e-quickorder-suggestions' ),
                        jSuggestionActive = jSuggestions.find( '.tt-selectable' ).filter( '.active' );
                    if ( jSuggestionActive.length === 0 && jSuggestions.css( 'display' ) === 'block' ) {
                        jQuery( this.form ).triggerHandler( 'submit' );
                    }
                }
            }
        } ).typeahead( {
            hint: true,
            highlight: true,
            minLength: 0,
            classNames: {
                wrapper: 'e-quickorder-typeahead-wrapper js-e-quickorder-typeahead-wrapper w-100',
                input: 'js-e-quickorder-input',
                menu: 'js-e-quickorder-suggestions e-quickorder-suggestions dropdown-menu w-100',
                suggestion: 'js-e-quickorder-suggestions-item dropdown-item',
                open: 'open',
                cursor: 'active',
                highlight: 'active'
            }
        }, {
            name: 'espresso',
            display: function ( suggestion ) {
                return suggestion.number + ' ' + suggestion.name;
            },
            limit: 8,
            async: true,
            source: e4.util.debounce(function ( query, syncResults, asyncResults ) {
                e4.quickorder.getSuggestions( query, function ( products ) {
                    var isEanNumber = e4.quickorder.isEanNumber(query),
                        isBulkOfProductIds = e4.quickorder.isBulkOfProductIds(query),
                        isNewlineSeperatedProductIds = e4.quickorder.isNewlineSeperatedProductIds(query);
                    if(isBulkOfProductIds || isNewlineSeperatedProductIds){
                        //e4.quickorder.addMultiToCart(query);
                    }
                    else if(isEanNumber){
                        if(products.length === 1){
                            e4.quickorder.addProduct( products[0] );
                        } else if(products.length === 0) {
                            e4.quickorder.showEanErrorMsg();
                        } else {
                            asyncResults( products );
                        }
                    } else {
                        asyncResults( products );
                    }
                } );
            }, e4.settings.debounceDelay.input )
        } ).on( 'typeahead:autocomplete typeahead:select', function ( event, product ) { // typeahead:cursorchange
            if ( product !== null ) {
                e4.quickorder.addProduct( product );
                jQuery( this ).typeahead( 'close' );
            }
        } );
    },
    showEanErrorMsg: function(){
        console.log('showEanErrorMsg', jQuery('.js-e-quickorder-form').find('.js-e-quickorder-input'));
        var jInput = jQuery('.js-e-quickorder-form').find('.js-e-quickorder-input');
        jInput.val('');
        jInput.attr('placeholder', 'No result!');
    },
    getSuggestions: e4.util.debounce( function ( query, asyncResults ) {
        if ( this.jqXHR !== undefined && this.jqXHR.readyState !== 4 ) {
            this.jqXHR.abort();
        }
        query = jQuery.trim( query );

        if ( query !== '' ) {

            jQuery('.js-e-quickorder-form').find('.js-e-quickorder-input').attr('placeholder', '');
            
            var objData = { q: query };
            if(e4.quickorder.isEanNumber(query)){
                objData = { ean: query.toString().padStart(13, '0') };
            }

            this.jqXHR = jQuery.ajax( {
                method: 'GET',
                url: e4.settings.ecom.quickorder.url,
                data: objData,
                dataType: 'json'
            } );
            this.jqXHR.done( function ( data ) {
                asyncResults( data.products );
            } );
        }
        //e4.settings.debounceDelay.input
    }, 100),
    isInt: function(strNumber){
        return strNumber % 1 === 0;
    },
    isEanNumber: function(strQuery){
        var returnValue = strQuery.length <= 13 && strQuery.length >= 11 && e4.quickorder.isInt(strQuery);
        return returnValue;
    },
    isBulkOfProductIds: function(strQuery){
        var arrQuery = strQuery.trim().split(','),
            isAllArrElementsInts = true;
        jQuery.each(arrQuery, function ( intIndex, strQueryPart ) {
            if(!e4.quickorder.isInt(strQueryPart)){
                isAllArrElementsInts = false;
            }
        });
        return (arrQuery.length > 1 && isAllArrElementsInts);
    },
    isNewlineSeperatedProductIds: function(strQuery){
        var arrQuery = strQuery.trim().split(' '),
            isAllArrElementsInts = true;
        jQuery.each(arrQuery, function ( intIndex, strQueryPart ) {
            if(!e4.quickorder.isInt(strQueryPart)){
                isAllArrElementsInts = false;
            }
        });
        return (arrQuery.length > 1 && isAllArrElementsInts);
    },
    postToCart: function(jsonData){
        var postData = {};
        postData['CartCmd'] = 'addmulti';
        if(jsonData.products.length > 0){
            jQuery.each(jsonData.products, function(intIndex, objProduct){
                postData['ProductLoopCounter'+intIndex] = intIndex;
                postData['ProductID'+intIndex] = objProduct.id;
                postData['VariantID'+intIndex] = objProduct.variantId;
                postData['UnitID'+intIndex] = '';
                postData['Quantity'+intIndex] = objProduct.colliQuantity;
            });
            e4.cart.addProduct(postData);
            e4.quickorder.clear();
        } else {
            alert('Beklager - Produkterne ikke længere tilgængelig');
        }
    },
    addMultiToCart: function(productIds){
        var objProductDataSettings = {
            ProductIds: productIds
        };

        jQuery.ajax( {
            method: 'GET',
            url: e4.settings.ecom.productlist.url,
            dataType: 'json',
            data: objProductDataSettings,
            beforeSend: function () {

            },
        } ).done( function ( jsonData ) {
            e4.quickorder.postToCart(jsonData);
        } );
    },
    focus: function () {
        var jQuickorder = jQuery( '.js-e-quickorder' ),
            intTarget = Math.ceil( jQuickorder.offset().top - jQuery( window ).height() + jQuickorder.height() + e4.scrollToAnchor.getNudge() );
        e4.scrollToAnchor.animate( intTarget, function () {
            if ( jQuery( document.activeElement ).is( '.js-e-orderline-quantity-input' ) !== true ) {
                jQuickorder.find( '.js-e-quickorder-input' ).focus();
            }
        } );
    },
    clear: function () {
        jQuery( '.js-e-quickorder-input' ).typeahead( 'val', '' );
    },
    addProduct: function ( objProduct ) {
        e4.cart.addProduct( {
            ProductID: objProduct.id,
            VariantID: objProduct.variantId,
            Quantity: objProduct.colliQuantity
        } );
        e4.quickorder.clear();
    }
};
